import HttpService from "@/services/http.service";
import { messagesService } from "@/services/messages.service";

class PolicyService extends HttpService {
  public async getAllPolicies() {
    try {
      this.uri = "/permission/policies";
      const query = {
        no_pagination: true
      };
      const resp = await super.get(query);
      return resp.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public async getServices() {
    this.uri = "/services";
    const resp = await super.get(this.query);
    return resp.data.data;
  }

  public async getPolicyTree() {
    try {
      this.uri = "/permission/categories/tree";
      const response = await super.get({});
      // temporary work around...
      return response.data.map((node: any) => {
        if (node.name === "BioTrack") {
          node.tag = "bdi";
        } else if (node.name === "CannaSuite") {
          node.tag = "core";
        } else {
          node.tag = "Applications";
        }
        return node;
      });
    } catch (error) {
      messagesService.renderErrorMessage(error);
    }
  }
}

export const policyService = new PolicyService();
